import qs from 'qs'
import axios from 'axios'
// import Vue from 'vue'
import router from '../router'
import { Message } from 'element-ui';
// let escape = window.escape

const instance = axios.create({
  baseURL: process.env.VUE_APP_URL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
})

// axios.defaults.baseURL = process.env.VUE_APP_URL;
// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
// let __iflytekToken__ = ''
instance.interceptors.request.use((request) => {
  // debugger
  // if (localStorage.getItem('token')) {
  //   request.headers['token'] = localStorage.getItem('token');
  //   request.headers['clientType'] = localStorage.getItem('clientType');
  //   request.headers['deviceId'] = window.SSO.getDeviceId(); // localStorage.getItem('deviceId');

  //   request.headers['appKey'] = localStorage.getItem('appKey');
  // }
  // if (!request.url.includes('/v2/files/')) {
  if (request.data && request.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
    request.data.st = window.localStorage.getItem('st')
    request.data.tgt = window.localStorage.getItem('tgt')
    request.data = qs.stringify(request.data, { allowDots: true })
  }
  if (request.method === 'get') {
    if (!request.params) {
      request.params = {}
    }
    request.params.st = window.localStorage.getItem('st')
    request.params.tgt = window.localStorage.getItem('tgt')
    request.params.t = new Date().getTime()
  }
  // } else if (request.method === 'post') {
  // warning: 注意，目前只对POST做CRSF防范，不考虑PUT,DELETE
  // request.headers['ecssafetytoken'] = __iflytekToken__
  // }
  // }

  return request
})

instance.interceptors.response.use(function (response) {
  // Do something with response data
  // if (response.headers['ecssafetytoken']) {
  //   __iflytekToken__ = response.headers['ecssafetytoken']
  // }
  return response
}, function (error) {
  // // Do something with response error
  if (error.response.headers['sessionstatus'] === 'no') {
    // router.push('/login')
    // window.location.href='/desktop/login'
    Message.warning('未登录，请先登录')
    router.push('/')
  } else if (error.response.headers['authoritystatus'] === 'no') {
    // 无权限
    console.log('无权限。。。。todo。。。')
  }
  return Promise.reject(error)
})

export function axiosFactory ({ method, url, params, data, ignore }) {
  return new Promise((resolve, reject) => {
    instance({
      method,
      url,
      params, // 不能再这里直接设置headers，会覆盖Authorization
      data
    }).then(({ data }) => {
      if (ignore) {
        resolve(data)
      } else {
        resolve(data)
      }
    }).catch((err) => {
      if (err.response.status == 403) {
        return;
      }
      let res = (err && err.response) || err
      reject(res)
    })
  })
}

export function axiosFormFactory ({ url, data }) {
  return new Promise((resolve, reject) => {
    instance({
      method: 'post',
      url,
      data,
      headers: { 'Content-Type': 'multipart/form-data' } // 不同的项目可能这里不同，具体请百度Content-type相关
    }).then(({ data }) => {
      resolve(data)
    }).catch((error) => {
      reject(error)
    })
  })
}

export function axiosPostFactory ({ url, data }) {
  return new Promise((resolve, reject) => {
    instance({
      method: 'post',
      url,
      data,
      headers: { 'Content-Type': 'application/json' } // 不同的项目可能这里不同，具体请百度Content-type相关
    }).then(({ data }) => {
      (data.success || data.code == '1') ? resolve(data) : reject(data)
    }).catch((error) => {
      reject(error)
    })
  })
}

export function exportFilePost({url, params, isData = true}) {
  if (isData) {
    return instance({
      responseType: 'arraybuffer',
      method: 'post',
      data: params,
      url: url
    })
  } else {
    return instance({
      responseType: 'arraybuffer',
      method: 'post',
      params: params,
      url: url
    })
  }
}
